/**
 * Translates API error messages to the current language.
 * Maps common backend error strings to i18n keys.
 */
export function translateError(msg, t) {
  if (!msg || !t) return msg;
  const map = {
    "Email already registered":         t("errors.emailTaken"),
    "Invalid email or password":        t("errors.invalidCredentials"),
    "Not authenticated":                t("errors.notAuthenticated"),
    "Only candidates can apply":        t("errors.onlyCandidates"),
    "Only employers can post jobs":     t("errors.onlyEmployers"),
    "Already applied for this job":     t("errors.alreadyApplied"),
    "Job not found":                    t("errors.jobNotFound"),
    "Job not found or not authorized":  t("errors.jobNotFound"),
    "CV not found":                     t("errors.cvNotFound"),
    "AI service not configured":        t("errors.aiNotConfigured"),
    "AI not configured":                t("errors.aiNotConfigured"),
    "This job is no longer accepting applications": t("errors.jobClosed"),
    "Selected CV version not found":    t("errors.cvVersionNotFound"),
    "Invalid or already used reset link": t("auth.invalidToken"),
    "This reset link has expired":      t("auth.expiredToken"),
    "Invalid reset link":               t("auth.invalidToken"),
    "New password must be at least 8 characters": t("auth.passwordTooShort"),
    "Current password is incorrect":    t("privacy.currentPasswordIncorrect"),
    "Invalid or already used verification link": t("emailVerify.invalidLink"),
    "This verification link has expired": t("emailVerify.expiredLink"),
    "Account suspended":                t("errors.accountSuspended"),
    "Invalid Google token":             t("errors.googleLoginFailed"),
    "Invalid Google token issuer":      t("errors.googleLoginFailed"),
    "Google account email is not verified": t("errors.googleEmailNotVerified"),
  };
  // Exact match first
  if (map[msg]) return map[msg];
  // Partial match
  for (const [key, val] of Object.entries(map)) {
    if (msg.includes(key)) return val;
  }
  // Generic fallback
  if (msg.toLowerCase().includes("session") || msg.toLowerCase().includes("token")) {
    return t("errors.sessionExpired");
  }
  return t("errors.unknownError") || msg;
}
